import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import UsageCard from "./UsageCard";
import usagesList from "./usagesList";
import { MultiViewSlider } from "reusableComponents";

const UsagesList = () => {
  const [isMobile, setIsMobile] = useState(false);
  const sliderRef = useRef(null);
  const { t } = useTranslation("global");
  const navigate = useNavigate();

  // Check if mobile on mount and resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Mobile drag functionality
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    if (!isMobile) return;
    setIsDragging(true);
    setStartX(e.pageX - sliderRef.current.offsetLeft);
    setScrollLeft(sliderRef.current.scrollLeft);
  };

  const handleMouseLeave = () => {
    if (!isMobile) return;
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    if (!isMobile) return;
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging || !isMobile) return;
    e.preventDefault();
    const x = e.pageX - sliderRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    sliderRef.current.scrollLeft = scrollLeft - walk;
  };

  // Touch events for mobile
  const handleTouchStart = (e) => {
    if (!isMobile) return;
  };

  const handleTouchEnd = () => {
    if (!isMobile) return;
  };

  const handleTouchMove = (e) => {
    if (!isMobile) return;
  };

  if (!usagesList.length) return <div className={styles.empty}>{t("global.noUsages")}</div>;

  const usageCards = usagesList.map((usage, index) => (
    <div key={index} className={`${isMobile ? styles.mobileSlide : ''} ${styles.usageCardWrapper}`}>
      <UsageCard
        usageImg={usage.usageImg}
        usageName={t(usage.usageKey)}
        usageMinPrice={`${t("space.from")} ${usage.usageMinPrice}`}
        usageLink={usage.usageLink}
      />
    </div>
  ));

  return (
    <div className={`${styles.usagesContainer} ${isMobile ? styles.mobile : ''}`}>
      {/* Desktop: Use MultiViewSlider */}
      {!isMobile && (
        <MultiViewSlider
          slidesNum={4}
          arrowStyle="square"
          arrowLeft="16px"
          arrowRight="16px"
          arrowTop="40%"
          speed={500}
          infinite={false}
          responsive={[
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
          ]}
        >
          {usageCards}
        </MultiViewSlider>
      )}

      {/* Mobile: Use custom scrolling */}
      {isMobile && (
        <div 
          ref={sliderRef}
          className={styles.mobileTrack}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
          onTouchMove={handleTouchMove}
        >
          {usageCards}
        </div>
      )}
    </div>
  );
};

export default UsagesList;